/**
 * Serialize the focused alarm row for "acknowledge this" / "delete this".
 * @param {object} context mounted page context
 * @return {object} public alarm context
 */
export function serializeAlarmsContext(context) {
	const route = String(context.route || '').toLowerCase();
	const onMaintenance = route === '/maintenance';
	const alarmId = context.alarm_id ?? context.alarmId;
	const alarmName = context.alarm_name ?? context.alarmName;
	const hasAlarm = onMaintenance &&
		typeof alarmId === 'string' &&
		Boolean(alarmId);
	return {
		alarm_id: hasAlarm ? alarmId : null,
		alarm_name: hasAlarm && typeof alarmName === 'string' && alarmName
			? alarmName
			: null,
	};
}
